/**
 * Dashboard — Quick Actions card
 */

import { Card } from '@elsapiens/ui'
import { Link } from 'react-router-dom'

interface QuickActionDef {
  to: string
  label: string
  iconBg: string
  path: string
}

const QUICK_ACTIONS: QuickActionDef[] = [
  {
    to: '/journal/new', label: 'New Journal Entry',
    iconBg: 'bg-accent text-primary',
    path: 'M12 4v16m8-8H4',
  },
  {
    to: '/accounts', label: 'Manage Accounts',
    iconBg: 'bg-green-100 dark:bg-green-900 text-green-600',
    path: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
  },
  {
    to: '/reports/trial-balance', label: 'View Reports',
    iconBg: 'bg-blue-100 dark:bg-blue-900 text-blue-600',
    path: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
  },
  {
    to: '/periods', label: 'Manage Periods',
    iconBg: 'bg-amber-100 dark:bg-amber-900 text-amber-600',
    path: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  },
  {
    to: '/reports/balance-sheet', label: 'Balance Sheet',
    iconBg: 'bg-purple-100 dark:bg-purple-900 text-purple-600',
    path: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  },
]

function QuickActionLink({ action }: { action: QuickActionDef }): JSX.Element {
  return (
    <Link
      className="flex items-center el-gap-sm el-py-xs rounded-lg hover:bg-muted transition-colors"
      to={action.to}
    >
      <div className={`w-9 h-9 rounded-lg ${action.iconBg} flex items-center justify-center flex-shrink-0`}>
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d={action.path} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        </svg>
      </div>
      <span className="text-sm">{action.label}</span>
    </Link>
  )
}

export function QuickActions(): JSX.Element {
  return (
    <Card>
      <h3 className="text-sm font-semibold el-mb-md">Quick Actions</h3>
      <div className="flex flex-col el-gap-xs">
        {QUICK_ACTIONS.map(action => (
          <QuickActionLink key={action.to} action={action} />
        ))}
      </div>
    </Card>
  )
}
